/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Team_Share_More_MembersInputs */



/**
* | output |
* | --- |
* | "+{count}" |
*
* @param {Team_Share_More_MembersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_share_more_members = /** @type {((inputs: Team_Share_More_MembersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Share_More_MembersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`+${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`+${i?.count}`)
	return /** @type {LocalizedString} */ (`+${i?.count}`)
});